import routerOptions0 from "/app/node_modules/.pnpm/nuxt@4.4.6_@babel+plugin-proposal-decorators@7.29.7_@babel+core@7.29.7__@babel+plugin-s_f7c2dbc4d9acd8450f0428bfc8612da0/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/app/apps/landing2-ui/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}